import { Component } from '@angular/core';
import { MainLayoutComponent } from "../main-layout/main-layout/main-layout.component";
import { HomeComponent } from "../../../home/home.component";

@Component({
  selector: 'otw-page-not-found',
  standalone: true,
  imports: [],
  templateUrl: './page-not-found.component.html',
  styles: ``
})
export class PageNotFoundComponent {

}
